import {ImageSizeType} from '../types/images-layer';

const useImagesGetSize = (
  stageSize: ImageSizeType,
  img1: HTMLImageElement | undefined,
  img2: HTMLImageElement | undefined,
  img3: HTMLImageElement | undefined
) => {

  const getScaledSize = (img: HTMLImageElement) : ImageSizeType => {
    if (!img) return {width: 0, height: 0};

    const imgRatio = img.width / img.height;

    const maxWidth = Math.min(stageSize.width, img.width) * 0.9;

    const maxHeight = maxWidth / imgRatio;

    const dimensions = {
      width: maxWidth,
      height: maxHeight
    };
    return dimensions;
  };

  const imageSizes = [img1, img2, img3].map((img) =>
    getScaledSize(img as HTMLImageElement)
  );

  const adjustedStageHeight = imageSizes[0].height;

  return {imageSizes, adjustedStageHeight};
};

export default useImagesGetSize;
